import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import { LoadingScreen } from '@/components/common/LoadingScreen'
import DiyPage from '@/features/projects/views/components/DiyPage'

/**
 * /projects/new - Browse templates and start a new project
 */
export const Route = createFileRoute('/_authed/projects/new/')({
  loader: async ({ context }) => {
    // Preload featured templates
    await context.queryClient.ensureQueryData(
      convexQuery(api.diy.templates.getFeaturedTemplates, { limit: 6 })
    )
    // Also preload empty search to have initial data ready
    await context.queryClient.ensureQueryData(
      convexQuery(api.diy.templates.searchTemplates, { searchTerm: ' ', limit: 12 })
    )
  },
  pendingComponent: () => <LoadingScreen message="Loading project templates..." />,
  component: NewProjectRouteWrapper,
})

function NewProjectRouteWrapper() {
  return (
    <Suspense fallback={<LoadingScreen message="Loading project templates..." />}>
      <DiyPage />
    </Suspense>
  )
}
